import Toaster from "@/src_new/shared/components/Toaster";
import { Navigate, Route, Routes } from "react-router-dom";

import CommonPopupHost from "@/src_new/shared/components/CommonPopupHost";
import AppShell from "@/src_new/shared/layout/AppShell";
import AuthLayout from "@/src_new/shared/layout/AuthLayout";
import ScrollToTop from "@/src_new/shared/layout/ScrollToTop";

import { App_Url_New } from "@/src_new/shared/common/static";
import Modal from "@/src_new/shared/components/Modal";
import { usePosterReducers } from "@/src_new/shared/redux/store/useGetData";
import * as app from "../../../import";

type AppRoute = {
  path: string;
  element: any;
  module?: string;
  action?: string;
};

const publicRoutes: AppRoute[] = [
  { path: App_Url_New.secured.frontlinks.login, element: <app.LoginPage /> },
];

const privateRoutes: AppRoute[] = [
  {
    path: App_Url_New.secured.frontlinks.dashboard,
    element: <app.Dashboard />,
    module: "dashboard",
    action: "view",
  },
  {
    path: App_Url_New.secured.frontlinks.leads,
    element: <app.Leads />,
    module: "pipeline",
    action: "view",
  },

  {
    path: "/leads/:id",
    element: <app.LeadDetail />,
    module: "pipeline",
    action: "view",
  },
  {
    path: App_Url_New.secured.frontlinks.pipelineAnalytics,
    element: <app.PipelineAnalytics />,
    module: "pipeline",
    action: "view",
  },
  {
    path: App_Url_New.secured.frontlinks.rfq,
    element: <app.RFQs />,
    module: "rfqs",
    action: "list",
  },
  {
    path: App_Url_New.secured.frontlinks.pipeline,
    element: <app.PipelineAnalytics />,
    module: "pipeline",
    action: "view",
  },
  {
    path: App_Url_New.secured.frontlinks.opportunities,
    element: <app.Opportunity />,
    module: "pipeline",
    action: "view",
  },
  {
    path: App_Url_New.secured.frontlinks.opportunitiesAdd,
    element: <app.OpportunityAdd />,
    module: "pipeline",
    action: "view",
  },
  {
    path: "/opportunities/edit/:quote_id/:step",
    element: <app.OpportunityEdit />,
    module: "pipeline",
    action: "view",
  },
  {
    path: App_Url_New.secured.frontlinks.policies,
    element: <app.Policies />,
    module: "policies",
    action: "view",
  },
  {
    path: `${App_Url_New.secured.frontlinks.policies}/:policyId`,
    element: <app.PolicyDetails />,
    module: "policies",
    action: "view",
  },
  {
    path: "/commissions",
    element: <app.Commissions />,
    module: "money",
    action: "view",
  },
  {
    path: "/payments",
    element: <app.Payments />,
    module: "money",
    action: "view",
  },
  {
    path: "/tax",
    element: <app.Tax />,
    module: "money",
    action: "view",
  },
  {
    path: "/knowledge",
    element: <app.Knowledge />,
    module: "quotes",
    action: "view",
  },
  {
    path: App_Url_New.secured.frontlinks.formConfig,
    element: <app.FormConfig />,
  },
  {
    path: `${App_Url_New.secured.frontlinks.formConfig}/:id`,
    element: <app.FormConfigDetail />,
  },
];

export default function AppRouter() {
  const {
    auth: { user },
  } = usePosterReducers();

  const permissionAliases: Record<string, string[]> = {
    insurerconfig: ["insurerconfig", "insurers", "insurer"],
    money: ["money", "commision", "commission", "commissions"],
  };

  const hasPermission = (module?: string, action?: string) => {
    if (!module || !action) return true;

    const modulesToCheck = permissionAliases[module] || [module];

    return modulesToCheck.some(
      (moduleKey) => user?.user?.role?.permissions?.[moduleKey]?.includes(action) ?? false
    );
  };

  const allowedPrivateRoutes = privateRoutes.filter((route) =>
    hasPermission(route.module, route.action)
  );

  const fallbackPrivatePath =
    allowedPrivateRoutes[0]?.path || App_Url_New.secured.frontlinks.dashboard;

  const renderRoutes = (routes: AppRoute[]) =>
    routes.map(({ path, element }) => <Route key={path} path={path} element={element} />);

  return (
    <>
      <ScrollToTop />
      <Routes>
        {user ? (
          <>
            <Route element={<AuthLayout />}>{renderRoutes(allowedPrivateRoutes)}</Route>
            <Route path="*" element={<Navigate to={fallbackPrivatePath} replace />} />
          </>
        ) : (
          <>
            <Route element={<AppShell />}>{renderRoutes(publicRoutes)}</Route>
            <Route path="*" element={<Navigate to={"/login"} replace />} />
          </>
        )}
      </Routes>
      <CommonPopupHost />
      <Modal />
      <Toaster />
    </>
  );
}
